import useIsMobile from "../../hooks/useIsMobile";

import CoordinatorDesktopLayout from "./CoordinatorDesktopLayout";
import CoordinatorMobileLayout from "./CoordinatorMobileLayout";

export default function CoordinatorLayout() {

    const isMobile =
        useIsMobile();

    if (isMobile) {

        return <CoordinatorMobileLayout />;

    }

    return <CoordinatorDesktopLayout />;

}